import { omniAtom } from "src/utils/atoms";

const prefix = "modals/deleteStorePogs";

interface DeleteStorePogModalData {
  storePogIds: number[];
  approvedCount: number;
  inProgressCount: number;
  isLastPog: boolean;
  merchflowId: number;
  onSuccess: () => void;
}

export const deleteStorePogModalAtom = omniAtom({
  prefix,
  key: "data",
  value: null as DeleteStorePogModalData | null,
});
